// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Heebo', 'Heebo Fallback'","fontStyle":"normal"},"className":"__className_e0ba24","variable":"__variable_e0ba24"};